import { getActivityFeedStore } from '../store/store';

export function getIsOpx(): boolean {
    return getActivityFeedStore().isOpx;
}
